module.exports = __webpack_public_path__ + "front/img/p4.5ef07bf1.png";